export default __webpack_public_path__ + "static/media/logo-legisnote-roxo.256a1ecb.svg";